var errorCodeConstants = {
  PAYMENT_INTENT_AUTHENTICATION_FAILURE: 'payment_intent_authentication_failure',
  STRIPE_BILLING_DETAILS_INCOMPLETE: 'stripe.billing_details.incomplete',
  STRIPE_DEFAULT_ERROR: 'stripe.default.error',
  STRIPE_NOT_LOADED: 'stripe.not.loaded',
  STRIPE_PAYMENT_DECLINED: 'stripe.payment.declined'
};
export { errorCodeConstants as default };